import {
  getApiV1ThreeLetterCodeClientAdminsClientAdminUsersId,
  getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  threeLetterCode: string;
  id: number;
};

type IUseGetClientAdminUser = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersId200;
};

/**
 * 企業管理者ユーザー詳細取得フック
 */
export const useGetClientAdminUser: IUseGetClientAdminUser = ({ threeLetterCode, id }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdKey(threeLetterCode, id),
    () => getApiV1ThreeLetterCodeClientAdminsClientAdminUsersId(threeLetterCode, id),
    { suspense: true }
  );

  return { data };
};
